import dynamic from 'next/dynamic';
import { EditableComponent } from '@adobe/aem-react-editable-components';
import { CARD_LAYERED_VARIATION } from '../../constants/OfferCardConstants';
import { MBE_OFFER } from '../../constants/OfferDetailsConstants';

import { StyledOfferCardsDivPreviewMode } from './OfferCardCaousel.styles';
import { OfferCardsProps } from './OfferCardCarousel.types';
import OffersCardCarouselSkeletonLoader from './OffersCardCarouselSkeletonLoader';

export const OfferCardCarouselWrapperConfig = {
  emptyLabel: 'OfferCardCarousel',
  isEmpty: false,
  resourceType: `mi-aem-offers-spa/components/offers-cards`,
};

export const OfferCardCarouselWrapper: React.FC<OfferCardsProps> = props => {
  const { noOfCards, cardsType = CARD_LAYERED_VARIATION } = props?.model || {};
  const CardCarousel = dynamic(() => import('./CardCarousel'), {
    loading: () => (
      <div className="container">
        <OffersCardCarouselSkeletonLoader cardType={cardsType} numberOfCards={noOfCards} />
      </div>
    ),
  });
  return <CardCarousel {...props} />;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const OfferCardCarousel = (props: any) => {
  const isPreviewMode = props?.offersData?.isPreview === 'true';
  const isMBEpreview = props?.offersData?.responseObject?.offers?.mbeOfferById?.offers?.type === MBE_OFFER;
  const isNonEditable = props.cqPath?.includes('experiencefragment');

  const carouselContent = (
    <div data-component-name="o-offers-cards" data-testid="offers-cards">
      <OfferCardCarouselWrapper {...props} />
    </div>
  );

  const carouselWrapper = isPreviewMode ? (
    <StyledOfferCardsDivPreviewMode isMBEpreview={isMBEpreview}>{carouselContent}</StyledOfferCardsDivPreviewMode>
  ) : (
    carouselContent
  );

  return isNonEditable ? (
    <div data-target-component={props?.model?.targetComponentName}>{carouselWrapper}</div>
  ) : (
    <div data-target-component={props?.model?.targetComponentName}>
      <EditableComponent config={OfferCardCarouselWrapperConfig} {...props}>
        <>{carouselWrapper}</>
      </EditableComponent>
    </div>
  );
};